import React from "react"

export interface TableProps {
    head: {
        id: string
        text: string
        asterisk?: string
    }[]
    body: {
        id: string
        text: string
    }[][]
}

const Table = ({ head, body }: TableProps) => {
    return (
        <div className="overflow-hidden border border-solid border-border-tide sm:rounded-base">
            <table className="w-full border-collapse text-xs sm:text-md">
                <tbody>
                    <tr>
                        {head.map(item => (
                            <th
                                key={item.id}
                                className="bg-darkblumine py-2.5 text-left text-white first:pl-6.25 last:pr-6.25 sm:py-5 sm:first:pl-5 sm:last:pr-5 md:first:pl-10 md:last:pr-10 lg:first:pl-15 lg:last:pr-15 xl:first:pl-20 xl:last:pr-20"
                            >
                                {item.text}
                                {item.asterisk && <sup>{item.asterisk}</sup>}
                            </th>
                        ))}
                    </tr>
                    {body.map((row, i) => (
                        <tr
                            key={i}
                            className="border-b border-solid border-border-tide last:border-b-0 odd:bg-background-tide"
                        >
                            {row.map(item => (
                                <td
                                    key={item.id}
                                    className="py-2.5 text-left whitespace-pre-wrap first:pl-6.25 last:pr-6.25 sm:py-5 sm:first:pl-5 sm:last:pr-5 md:first:pl-10 md:last:pr-10 lg:first:pl-15 lg:last:pr-15 xl:first:pl-20 xl:last:pr-20"
                                >
                                    {item.text === "check" ? <i className="lavita-icon"></i> : item.text}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default Table
